import { EventCard } from '@components/EntryCard';
import { createBlock } from '@lib/features/blocks/blocks';
import { Entry } from '@lib/features/entries';
import { useAppLink } from '@lib/store';
import { useEffect } from 'react';
import EventCards from './EventCards';
import { useEvents } from './useEvents';

const EventCardsBlock = createBlock<'blocks_eventCards_BlockType'>(
  ({ heading, content, eventMultiple: maybeEvents }) => {
    const { trigger, items } = useEvents();
    const indexLink = useAppLink('eventIndex');

    useEffect(() => {
      if (maybeEvents?.length) return;
      trigger({ isEverydayEvent: false, limit: 4 });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trigger]);

    return (
      <EventCards
        {...{
          Component: EventCard,
          heading,
          content,
          items: maybeEvents?.length ? (maybeEvents as Entry<'event'>[]) : items,
          indexLink,
        }}
      />
    );
  }
);

export default EventCardsBlock;
